<script setup>
import StartupEditField from "@/components/startups/startupEdit/StartupEditField.vue";
import {inject} from "vue";

defineProps(['hasAiFieldsLogs']);
const id = inject('id');
</script>

<template>
    <div>
        <StartupEditField
            field-name="geminiTrlScore"
            label="TRL Score"
            type="textarea"
        />

        <StartupEditField
            field-name="geminiTam"
            label="TAM"
            type="textarea"
        />

        <StartupEditField
            field-name="geminiFoundersHistory"
            label="Founders History"
            type="textarea"
        />

        <StartupEditField
            field-name="geminiPatents"
            label="Patents"
            type="textarea"
        />

        <StartupEditField
            field-name="geminiGeographicalPresence"
            label="Geographical Presence"
            type="textarea"
        />

        <a
            v-if="hasAiFieldsLogs"
            class="light-select"
            :href="`/ai-fields-logs?startup_id=${id}`"
            target="_blank"
        >
            View Logs
        </a>
    </div>
</template>

<style scoped>

</style>
